import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LocalstorageService } from './services/localstorage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private localstorageService: LocalstorageService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.localstorageService.get('token');

    if (!token && window.location.hash !== '#/main' && window.location.hash !== '#/launcher') {
      this.router.navigateByUrl('/main').then();
    }

    let req = request;
    if(token){
      req = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + token,
          'Accept-Language': 'ru',
        },
      });
    }


    return next.handle(req).pipe(catchError((error) => {
      this.handleAuthError(error);
      return of(error);
    }) as any);
  }


  private handleAuthError(error: HttpErrorResponse): Observable<any> {
    if (error.status === 401 || error.status === 403 || error.status === 504) {
      this.router.navigateByUrl('/main');
      return of(error.message);
    }
    throw error;
  }


}
